/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PortfolioDto } from '../../models/portfolio-dto';

export interface PortfolioAdminControllerDeleteV1$Params {
  id: string;
}

export function portfolioAdminControllerDeleteV1(http: HttpClient, rootUrl: string, params: PortfolioAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PortfolioDto>> {
  const rb = new RequestBuilder(rootUrl, portfolioAdminControllerDeleteV1.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PortfolioDto>;
    })
  );
}

portfolioAdminControllerDeleteV1.PATH = '/api/v1/portfolios/admin/{id}';
